import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import '../styles/ManageRolesPage.css';
import Panel from '../components/Panel';
import axios from '../services/axiosConfig';
import { authService } from '../services/authService';
import { useSession } from '../context/SessionContext';
//import Cookies from 'js-cookie';

// Helper function to get token from various sources
// const getTokenFromSources = async () => {
//   // Try cookies first
//   const cookieToken = Cookies.get('auth_token') || Cookies.get('token') || Cookies.get('jwt');
//   if (cookieToken) {
//     console.log('Using auth token from cookie');
//     return cookieToken;
//   }

  // Try session storage next
//   const sessionToken = sessionStorage.getItem('authToken');
//   if (sessionToken) {
//     console.log('Using auth token from session storage');
//     return sessionToken;
//   }

//   // Finally try the auth service
//   try {
//     const token = await authService.acquireTokenForAPI();
//     if (token) {
//       console.log('Using auth token from authService');
//       // Save token to session storage for future use
//       sessionStorage.setItem('authToken', token);
//       return token;
//     }
//   } catch (error) {
//     console.warn('Error acquiring token from authService:', error);
//   }

//   console.warn('No auth token found');
//   return null;
// };
    
const ManageRoles = () => {
    // Get API URL from environment variables
    const API_URL = process.env.REACT_APP_API_URL;
    
    // State for roles management
      const [roles, setRoles] = useState([]);
      const [loading, setLoading] = useState(false);
      const [error, setError] = useState(null);
const [isInternalRolesPanelOpen, setIsInternalRolesPanelOpen] = useState(true);
// State for internal roles
  const [internalRoles, setInternalRoles] = useState([]);
  const [selectedInternalRole, setSelectedInternalRole] = useState(null);
  const [newInternalRoleName, setNewInternalRoleName] = useState('');
  const [newInternalRoleDescription, setNewInternalRoleDescription] = useState('');
  
  // State for external roles
  const [externalRoles, setExternalRoles] = useState([]);
  const [filteredExternalRoles, setFilteredExternalRoles] = useState([]);
  const [externalRolesFilter, setExternalRolesFilter] = useState('');
  const [mappedExternalRoles, setMappedExternalRoles] = useState([]);
  const [selectedExternalRoles,setSelectedExternalRoles]= useState([]); 
 const [selectedMappedRole, setSelectedMappedRole] = useState([]);
const { userId, userRoles, isAdmin, userName } = useSession();
  

  // Update the logic to fetch and populate internal roles dropdown
  useEffect(() => {
    const loadInternalRoles = async () => {
      try {
        // Get token from all possible sources
        //const token = await getTokenFromSources();
        
        // Configure request options with token handling
        const requestOptions = {
          withCredentials: true, // Always include cookies
          headers: {}
        };
        
        // Add Authorization header if token is available
        // if (token) {
        //   requestOptions.headers['Authorization'] = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
        // }
        
       // console.log('Loading internal roles with token:', token ? 'Token available' : 'No token');
        
        const response = await axios.get(`${API_URL}/ConfigExternalRoles/LoadInternalRoles`, requestOptions);
        const roles = response.data.internalRoles;
        const options = roles.map(role => ({
          id: role.id,
          roleName: role.roleName
        }));
        setInternalRoles(options);
      } catch (error) {
        console.error('Error loading internal roles:', error);
        if (error.response) {
          console.error('Response status:', error.response.status);
          console.error('Response data:', error.response.data);
        }
        toast.error('Failed to load internal roles');
      }
    };

    loadInternalRoles();
  }, [API_URL]);

    // Add functionality to call the API when the Save button is clicked
    const handleSaveInternalRole = async () => {
      if (!newInternalRoleName.trim() || !newInternalRoleDescription.trim()) {
        toast.error('Role name and description are required');
        return;
      }
  
      const payload = {
        roleName: newInternalRoleName,
        description: newInternalRoleDescription,
        userID: userId, // Use the userId from session context
      };
  
      console.log('Payload being sent to API:', payload); // Log the payload
  
      try {
        // Get token from all possible sources
       // const token = await getTokenFromSources();
        
        // Configure request options with token handling
        const requestOptions = {
          withCredentials: true, // Always include cookies
          headers: {}
        };
        
        // Add Authorization header if token is available
        // if (token) {
        //   requestOptions.headers['Authorization'] = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
        // }
        
        //console.log('Saving internal role with token:', token ? 'Token available' : 'No token');
        
        const response = await axios.post(`${API_URL}/ManageRoles/SaveInternalRole`, payload, requestOptions);
  
        if (response.data) {
          toast.success('Internal role saved successfully');
          setInternalRoles([...internalRoles, response.data]);
          setNewInternalRoleName('');
          setNewInternalRoleDescription('');
        } else {
          console.error('Error response from server:', response);
          toast.error('Failed to save internal role');
        }
      } catch (error) {
        console.error('An error occurred while saving the internal role:', error);
        if (error.response) {
          console.error('Response status:', error.response.status);
          console.error('Response data:', error.response.data);
        }
        toast.error('An error occurred while saving the internal role');
      }
    };

      // Update the fetchMappedExternalRoles function to handle the API response correctly
const fetchMappedExternalRoles = async (internalRoleId) => {
    try {
      setLoading(true);
      
      // Get token from all possible sources
      // const token = await getTokenFromSources();
      
      // Configure request options with token handling
      const requestOptions = {
        withCredentials: true, // Always include cookies
        params: { internalRoleId },
        headers: {}
      };
      
      // Add Authorization header if token is available
      // if (token) {
      //   requestOptions.headers['Authorization'] = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
      // }
      
      //console.log('Fetching mapped external roles with token:', token ? 'Token available' : 'No token');
      
      const response = await axios.get(`${API_URL}/ManageRoles/GetMappedRoles`, requestOptions);
  
      if (response.status === 200 && response.data.success) {
        const roles = response.data.mappedExternalRoles;
  
        // Transform data for mapped external roles
        const mappedRoles = roles.map(role => ({
          value: role.externalRoleId,
          label: role.externalRoleName,
          selected: role.checked // Use the `checked` property from the API response
        }));
  
        setMappedExternalRoles(mappedRoles);
        
        // Update the selection state in filteredExternalRoles as well
        setFilteredExternalRoles(prevRoles => 
          prevRoles.map(role => {
            const mappedRole = roles.find(mr => mr.externalRoleId === role.value);
            return mappedRole ? { ...role, selected: mappedRole.checked } : role;
          })
        );
      } else {
        throw new Error(`Unexpected response or status: ${response.status}`);
      }
    } catch (error) {
      console.error('Error fetching mapped external roles:', error);
      if (error.response) {
        console.error('Response status:', error.response.status);
        console.error('Response data:', error.response.data);
      }
      toast.error('Failed to fetch mapped external roles');
    } finally {
      setLoading(false);
    }
  };

  // Update the internal role selection logic to fetch mapped external roles
  useEffect(() => {
    if (selectedInternalRole) {
      fetchMappedExternalRoles(selectedInternalRole);
    } else {
      setMappedExternalRoles([]); // Clear mapped roles if no internal role is selected
    }
  }, [selectedInternalRole]);

    // Handle deleting an internal role
    const handleDeleteInternalRole = async () => {
      if (!selectedInternalRole) {
        toast.error('Please select a role to delete');
        return;
      }
  
      try {
        // Get token from all possible sources
       // const token = await getTokenFromSources();
        
        // Configure request options with token handling
        const requestOptions = {
          withCredentials: true, // Always include cookies
          params: { UserID: userId },
          headers: {}
        };
        
        // Add Authorization header if token is available
        // if (token) {
        //   requestOptions.headers['Authorization'] = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
        // }
        
        // console.log('Deleting internal role with token:', token ? 'Token available' : 'No token');
        
        const response = await axios.delete(`${API_URL}/ManageRoles/DeleteInternalRole/${selectedInternalRole}`, requestOptions);
  
        if (response.status === 200) {
          toast.success('Internal role deleted successfully');
          setInternalRoles(internalRoles.filter(role => role.id !== selectedInternalRole));
          setSelectedInternalRole(null);
        } else {
          toast.error('Failed to delete internal role');
        }
      } catch (error) {
        console.error('Error deleting internal role:', error);
        if (error.response) {
          console.error('Response status:', error.response.status);
          console.error('Response data:', error.response.data);
        }
        toast.error('An error occurred while deleting the internal role');
      }
    };
  
  // Fetch external roles from the server
 useEffect(() => {
    const loadExternalRoles = async (retryCount = 0) => {
      try {
        setLoading(true);
        // Get token from all possible sources
        //const token = await getTokenFromSources();
        
        // Configure request options with token handling
        const requestOptions = {
          withCredentials: true, // Always include cookies
          params: { userId: userId }, // Pass userId from session as a parameter
          headers: {}
        };
        
        // Add Authorization header if token is available
        // if (token) {
        //   requestOptions.headers['Authorization'] = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
        // }

        console.log('Loading external roles');

        const response = await axios.get(`${API_URL}/ManageRoles/LoadExternalRoles`, requestOptions);

        if (response.status === 200) {
          console.log('API Response:', response.data);

          const roles = response.data.externalRoles;
          console.log('Extracted Roles:', roles);

          // Transform data for dropdown
          const options = roles.map(role => ({
            value: role.externalRoleId,
            label: role.externalRoleName,
            key: role.externalRoleId, // Ensure unique key for React
            selected: role.checked // Case-sensitive comparison
          }));

          setExternalRoles(options);
          setFilteredExternalRoles(options);
        } else {
          throw new Error(`Unexpected response status: ${response.status}`);
        }
      } catch (error) {
        if (error.response && error.response.status === 500 && retryCount < 5) {
          const retryDelay = Math.pow(2, retryCount) * 1000; // Exponential backoff
          console.log(`Retrying after ${retryDelay / 1000} seconds...`);
          setTimeout(() => loadExternalRoles(retryCount + 1), retryDelay);
        } else {
          console.error('Error loading external roles:', error);
          if (error.response) {
            console.error('Response status:', error.response.status);
            console.error('Response data:', error.response.data);
          }
          toast.error('Failed to load external roles');
        }
      } finally {
        setLoading(false);
      }
    };

    loadExternalRoles();
  }, [API_URL, userId]);
  
    
  // Filter external roles based on search input
  const filterExternalRoles = (searchTerm) => {
    setExternalRolesFilter(searchTerm);

    if (!searchTerm) {
      setFilteredExternalRoles(externalRoles);
      return;
    }

    const filtered = externalRoles.filter(role => 
      role.label.toLowerCase().includes(searchTerm.toLowerCase())
    );

    setFilteredExternalRoles(filtered);
  };

   // Initialize `mappedExternalRoles` with preselected roles when the UI loads
    useEffect(() => {
      if (externalRoles.length > 0 && mappedExternalRoles.length === 0) {
        const preselectedRoles = externalRoles.filter((role) => role.selected);
        setMappedExternalRoles(preselectedRoles);
      }
    }, [externalRoles]); // Added condition to ensure it runs only when mappedExternalRoles is empty
  // Refined the logic for handling individual checkbox state updates
  const handleExternalRoleCheckboxChange = (roleId, checked) => {
    setExternalRoles((prevRoles) =>
      prevRoles.map((role) =>
        role.value === roleId ? { ...role, selected: checked } : role
      )
    );

    setFilteredExternalRoles((prevFilteredRoles) =>
      prevFilteredRoles.map((role) =>
        role.value === roleId ? { ...role, selected: checked } : role
      )
    );
  };

    // Function to map selected external roles to mapped external roles
    const mapExternalRoles = () => {
      const selectedRoles = externalRoles.filter(role => role.selected);
  
      setMappedExternalRoles((prevMappedRoles) => {
        const updatedMappedRoles = [...prevMappedRoles];
        selectedRoles.forEach(role => {
          if (!updatedMappedRoles.some(mappedRole => mappedRole.value === role.value)) {
            updatedMappedRoles.push(role);
          }
        });
        return updatedMappedRoles;
      });
  
      toast.success('External roles mapped successfully');
    };

      // Unmap external roles from internal role
      const unmapExternalRoles = (roleId) => {
        if (!roleId) {
          toast.error('Please select a role to unmap');
          return;
        }
    
        // Remove only the clicked role from mappedExternalRoles
        setMappedExternalRoles(mappedExternalRoles.filter(role => role.value !== roleId));
    
        // Uncheck the clicked role in external roles
        setFilteredExternalRoles(filteredExternalRoles.map(role => {
          if (role.value === roleId) {
            return { ...role, selected: false };
          }
          return role;
        }));
    
        toast.success('External role unmapped successfully');
      };

      // Update the handleMappedRoleClick function to toggle background color on click
  const handleMappedRoleClick = (roleId) => {
    setSelectedMappedRole((prevSelected) => {
      // Toggle selection and update background color
      return prevSelected === roleId ? null : roleId;
    });
  };

    // Add functionality to call the API when the Save button is clicked
    const handleSaveExternalRoles = async () => {
      const payload = {
          mappedRoles: filteredExternalRoles
              .filter(role => role.selected) // Only include checked roles
              .map(role => ({
                  externalRoleId: String(role.value),
                  externalRoleName: String(role.label),
                  externalRoleDesc: String(role.label), // Assuming description is same as label
                  checked: true,
                  
              }))
      };
  
      console.log('Payload being sent to API:', payload); // Log the payload
  
      try {
          // Get token from all possible sources
        //  const token = await getTokenFromSources();
          
          // Configure request options with token handling
          const requestOptions = {
            withCredentials: true, // Always include cookies
            headers: {}
          };
          
          // Add Authorization header if token is available
          // if (token) {
          //   requestOptions.headers['Authorization'] = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
          // }
          console.log('Saving external roles');
          
          const response = await axios.post(`${API_URL}/ManageRoles/SaveExternalRoles`, payload, requestOptions);
  
          if (response.status === 200) {
              toast.success('External roles saved successfully');
          } else {
              toast.error('Failed to save external roles');
          }
      } catch (error) {
          console.error('Error saving external roles:', error);
          if (error.response) {
            console.error('Response status:', error.response.status);
            console.error('Response data:', error.response.data);
          }
          toast.error('An error occurred while saving external roles');
      }
  };
  
// Define the state and function for toggling the panel
const [isPanelOpen, setIsPanelOpen] = useState(true);

const togglePanel = () => {
  setIsPanelOpen((prevState) => !prevState);
};

    return (
    <Panel title={
      <div className="panel-title-container">
        <span className="panel-title-text">Manage Roles</span>
        <span
          className="panel-toggle"
          onClick={togglePanel}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              togglePanel();
            }
          }}
          tabIndex="0"
          role="button"
          aria-expanded={isPanelOpen}
          aria-label={`${isPanelOpen ? 'Collapse' : 'Expand'} Manage Roles panel`}
        >
          {isPanelOpen ? '▼' : '▶'}
        </span>
      </div>
    }>
      {isPanelOpen && (
        <div className="role-management-container">
          <div className="roles-grid" >
            <div className="roles-grid-left ">
              <span  className="span-title">Manage Internal User Roles</span>
              <form onSubmit={(e) => {
  e.preventDefault();
  handleSaveInternalRole();
}}>
  <div >
    <label>Add Internal Roles</label>
    <span className="required">*</span>
    <input 
      type="text" 
      value={newInternalRoleName} 
      onChange={(e) => setNewInternalRoleName(e.target.value)}
      placeholder="Enter role name"
      className="form-control input-wide"
       style={{ marginBottom: '10px' }}
    />
  </div>

  <div >
    <label>Description</label>
    <span className="required">*</span>
    <input 
      type="text" 
      value={newInternalRoleDescription} 
      onChange={(e) => setNewInternalRoleDescription(e.target.value)}
      placeholder="Enter role description"
      className="form-control input-wide"
      style={{ marginBottom: '10px' }}
    />
    
  </div>

  <div className="button-group">
    <button type="submit" className="btn button">Add</button>
    <button type="button" className="btn button" onClick={() => {
      setNewInternalRoleName('');
      setNewInternalRoleDescription('');
    }}>Cancel</button>
  </div>

  <div >
    <label>Added Internal Roles</label>
    <select 
      className="form-control input-medium"
      value={selectedInternalRole || ''}
      onChange={(e) => {
        const selectedRoleId = e.target.value ? Number(e.target.value) : null;
        setSelectedInternalRole(selectedRoleId);
        if (selectedRoleId) {
          fetchMappedExternalRoles(selectedRoleId);
        }
      }}
    >
      <option value="">Select</option>
      {internalRoles.map(role => (
        <option key={role.id} value={role.id}>{role.roleName}</option>
      ))}
    </select>
  </div>

  <div className="button-group">
    <button type="button" className="btn  button" onClick={handleDeleteInternalRole} >
      Delete
    </button>
    <button type="button" className="btn  button" onClick={() => setSelectedInternalRole(null)}>
      Cancel
    </button>
  </div>
</form>

            </div>
            
            <div className="vertical-divider"></div>
            
            <div className="roles-grid-right ">
              <span className="span-title">Manage External User Roles</span>
              {/* Manage External User Roles */}
              <div className="manage-external-user-roles">
                  <div>
                  <label>External Roles</label>
                  <div className="roles-list">
                  <input
                    type="text"
                    value={externalRolesFilter}
                    onChange={(e) => filterExternalRoles(e.target.value)}
                    placeholder="Filter External Roles..."
                    className="form-control"
                  />
                  
                  <div>
                    {/* Add a Select All checkbox for external roles */}
                    <div className="role-item">
                      <input
                      className="role-item"
                        type="checkbox"
                        id="select-all-external-roles"
                        checked={filteredExternalRoles.every(role => role.selected)}
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          setFilteredExternalRoles(filteredExternalRoles.map(role => ({ ...role, selected: isChecked })));
                        }}
                      />
                      <label htmlFor="select-all-external-roles">Select All</label>
                    </div>
                    
                    {filteredExternalRoles.map((role) => (
                      <div key={role.value} className="role-item">
                        <input
                        className="role-item"
                          type="checkbox"
                          id={`ext-role-${role.value}`}
                          value={role.value}
                          checked={role.selected || false}
                          onChange={(e) => handleExternalRoleCheckboxChange(role.value, e.target.checked)}
                        />
                        <label htmlFor={`ext-role-${role.value}`}>{role.label}</label>
                      </div>
                    ))}
                  </div>
                  </div>
                </div>

                <div className="mapping-buttons">
                  <button className="btn button1" onClick={mapExternalRoles}>&gt;&gt;</button>
                  <button className="btn button1" onClick={() => {
                    unmapExternalRoles(selectedMappedRole);
                    console.log('Mapped External Roles after unmapping:', mappedExternalRoles);
                  }}>&lt;&lt;</button>
                </div>

               <div>
                  <label>Mapped External Roles</label>
                  <div className="roles-list">
                  <ul>
                    {mappedExternalRoles.map((role) => (
                      <li
                        key={role.value}
                        className={`role-item clickable mapped-role-item ${selectedMappedRole === role.value ? 'selected' : ''}`}
                        onClick={() => handleMappedRoleClick(role.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            handleMappedRoleClick(role.value);
                          }
                        }}
                        tabIndex="0"
                        role="button"
                        aria-pressed={selectedMappedRole === role.value}
                        aria-label={`Select mapped role ${role.label}`}
                      >
                        {role.label}
                      </li>
                    ))}
                  </ul>
                </div>
                </div>

              
              </div>
              <div className="button-group button-group-centered">
                <button className="btn  button" onClick={handleSaveExternalRoles}>Save</button>
                <button className="btn  button" onClick={() => {
                  setNewInternalRoleName('');
                  setNewInternalRoleDescription('');
                }}>Cancel</button>
              </div>  
            </div>
          </div>
        </div>
      )}
    
  </Panel>
)

}

export default ManageRoles;


